import {
    SET_EMAIL_VALUE,
    SET_NAME_VALUE,
    SET_TRIP_TYPE_VALUE,
    SET_COVER_FOR_VALUE,
    SET_DEPARTURE_COUNRTY_VALUE,
    SET_DESTINATION_COUNRTY_VALUE,
    SET_DEPARTURE_DATE_VALUE,
    SET_RETURN_DATE_VALUE,
    SET_NO_OF_TRAVELLERS_VALUE,
    SET_NO_OF_MINORS_VALUE,
    SET_NO_OF_ADULTS_VALUE,
    SET_NO_OF_SENIORS_VALUE,
    SET_DOB_VALUE,
    setEmailValid,
    setNameValid,
    setPhoneNoValid,
    setTripTypeValid,
    setCoverForValid,
    setDepartureCountryValid,
    setDestinationCountryValid,
    setDepatureDateValid,
    setReturnDateValid,
    setNoOfTravellersValid,
    setNoOfMinorsValid,
    setNoOfAdultsValid,
    setNoOfSeniorsValid,
    setDobDateValid,
    SET_PHONE_NO_VALUE,
    SET_NO_OF_SENIORS_76_VALUE,
    setNoOfSeniors76Valid,
    SET_NO_OF_SENIORS_81_VALUE,
    setNoOfSeniors81Valid,
} from '../../../actions/travelKe/quote';

import { getDepatureDate, getSelectedCover } from '../../../selectors/travelKe/quote';

import {
    validateSelection,
    validateNumber,
    validateEmail,
    validateDate,
    validateName,
    validateDateOfBirth,
    validateNumericString,
    validateCellphoneNumber,
} from '@om/validation';
import { validationIsEqual } from '../status';

const validateStringArray = (value, { min, subject }) => {
    if (value.length < min) {
        return `You must select at least ${min} ${subject}.`;
    }
    return null;
};

let prevValidationAction = null;
export const quoteFormValidation = (store, next, action) => {
    const state = store.getState();
    const selectedCover = getSelectedCover(state);
    const depatureDate = getDepatureDate(state);
    function calculateFutureDates(dateString) {
        // Parse the date string in DD/MM/YYYY format
        if (typeof dateString !== 'string') {
            return false;
        }
        const [day, month, year] = dateString?.split('/').map(Number);
        const startDate = new Date(year, month - 1, day); // JavaScript months are 0-indexed

        if (isNaN(startDate)) {
            console.log('Invalid date format. Please use DD/MM/YYYY.');
            return false;
        }

        const sixMonthsDate = new Date(startDate);
        const twelveMonthsDate = new Date(startDate);
        const pilgrimageDateLimit = new Date(startDate);

        // Add 6 months to the sixMonthsDate
        sixMonthsDate.setMonth(sixMonthsDate.getMonth() + 6);

        // Calculate the 12-month date by adding 364 days
        twelveMonthsDate.setDate(twelveMonthsDate.getDate() + 364);

        // Add 44 days to the pilgrimageDateLimit
        pilgrimageDateLimit.setDate(pilgrimageDateLimit.getDate() + 44);

        // Helper function to format the date as DD/MM/YYYY
        const formatToDMY = (date) => {
            const d = date.getDate().toString().padStart(2, '0');
            const m = (date.getMonth() + 1).toString().padStart(2, '0');
            const y = date.getFullYear();
            return `${d}/${m}/${y}`;
        };

        return {
            sixMonthsDate: formatToDMY(sixMonthsDate) || '',
            twelveMonthsDate: formatToDMY(twelveMonthsDate) || '',
            pilgrimageDateLimit: formatToDMY(pilgrimageDateLimit) || '',
        };
    }
    const { sixMonthsDate, twelveMonthsDate, pilgrimageDateLimit } = calculateFutureDates(depatureDate.value);

    const validationAction = (() => {
        let error;
        let today = new Date();
        let validTodayDate = today.toLocaleDateString('en-NG').split('/').join('/');
        switch (action.type) {
            case SET_PHONE_NO_VALUE:
                error = validateCellphoneNumber(action.value, {
                    required: true,
                    min: 1,
                    subject: 'Phone number',
                    countryCode: 'ke',
                });
                return setPhoneNoValid(error);
            case SET_EMAIL_VALUE:
                error = validateEmail(action.value, { required: true, min: 1, subject: 'Email' });
                return setEmailValid(error);
            case SET_NAME_VALUE:
                error = validateName(action.value, { required: true, min: 1, subject: 'Name' });
                return setNameValid(error);
            case SET_TRIP_TYPE_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Trip type value' });
                return setTripTypeValid(error);
            case SET_COVER_FOR_VALUE:
                error = validateSelection(action.value, { min: 1, subject: 'Cover for value' });
                return setCoverForValid(error);
            case SET_DEPARTURE_COUNRTY_VALUE:
                error = validateName(action.value, { min: 1, subject: 'Departure country' });
                return setDepartureCountryValid(error);
            case SET_DESTINATION_COUNRTY_VALUE:
                error = validateName(action.value, { min: 1, subject: 'Destination country' });
                return setDestinationCountryValid(error);
            case SET_DEPARTURE_DATE_VALUE:
                error = validateDate(action.value, { required: true, min: validTodayDate, subject: 'Departure date' });
                return setDepatureDateValid(error);
            case SET_RETURN_DATE_VALUE:
                if (selectedCover.value === 'student') {
                    error = validateDate(action.value, {
                        required: true,
                        min: sixMonthsDate,
                        max: twelveMonthsDate,
                        subject: 'Return date',
                    });
                } else {
                    error = validateDate(action.value, {
                        required: true,
                        subject: 'Return date',
                        min: depatureDate.value,
                        max: selectedCover.value === 'pilgrimage' ? pilgrimageDateLimit : twelveMonthsDate,
                    });
                }
                return setReturnDateValid(error);
            case SET_NO_OF_TRAVELLERS_VALUE:
                error = validateNumericString(action.value, { min: 1, subject: 'Number of travellers' });
                return setNoOfTravellersValid(error);
            case SET_NO_OF_MINORS_VALUE:
                error = validateNumericString(action.value, { min: 1, subject: 'Number of minors' });
                return setNoOfMinorsValid(error);
            case SET_NO_OF_ADULTS_VALUE:
                error = validateNumericString(action.value, { min: 1, subject: 'Number of adults' });
                return setNoOfAdultsValid(error);
            case SET_NO_OF_SENIORS_VALUE:
                error = validateNumericString(action.value, { min: 1, subject: 'Number of seniors' });
                return setNoOfSeniorsValid(error);
            case SET_NO_OF_SENIORS_76_VALUE:
                error = validateNumericString(action.value, { min: 1, subject: 'Number of seniors 76' });
                return setNoOfSeniors76Valid(error);
            case SET_NO_OF_SENIORS_81_VALUE:
                error = validateNumericString(action.value, { min: 1, subject: 'Number of seniors 81' });
                return setNoOfSeniors81Valid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
